/**
 * Phone number regex for North American numbers
 *
 * Supports the following formats:
 * - 1234567890 (just 10 digits)
 * - 123-456-7890 (dashes between groups)
 * - 123.456.7890 (dots between groups)
 * - 123 456 7890 (spaces between groups)
 * - (123)456-7890 (parentheses around area code, no space after)
 * - (123) 456-7890 (parentheses around area code, with space after)
 * - 18004567890 (with country code and no space before parentheses)
 * - +1 123 456 7890 (with country code and spaces)
 * - +1(123)456-7890 (with country code and no space before parentheses)
 */
export const phoneNumberRegex =
  /^(?:\+?(\d{1,3})[-.\s]?)?(?:\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/;

/**
 * This is the email regex that Auth0 uses.
 *
 * https://github.com/auth0/lock/blob/4aaefa4a9ed00423e665e0743a7b0a952c6a267d/src/field/email.js#L7
 */
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
